/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactNode } from "react";
import { Box } from "@mui/material";
import { FakeInputContainer } from "../divs";
import { InputWithNoBorder } from "../inputs";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  iconSrc: string | ReactNode;
  color: string | undefined;
  clickIconFunction?: () => void;
}

const InputWithIcon: React.FC<InputProps> = (props: InputProps) => {
  return (
    <FakeInputContainer color={props.color} width="100%">
      {
        //@ts-ignore
        <InputWithNoBorder {...props} width="90%" />
      }
      {typeof props.iconSrc === "string" ?
        <img
          onClick={props.clickIconFunction}
          src={props.iconSrc}
          alt="icon"
          className="absoluteIcon"
        />
      : <Box sx={{ display: "flex", alignItems: "center" }}>
          {props.iconSrc}
        </Box>
      }
    </FakeInputContainer>
  );
};

export default InputWithIcon;
